import { Directive, ElementRef, HostListener } from '@angular/core';
/**
 * A custom directive that restricts an input field to accept only integer (numeric) values.
 * 
 * This directive is applied to `input` elements using the `integerOnly` attribute.
 * When the user types in the input field, any non-numeric characters are automatically removed
 * and the input will only contain digits (0-9).
 * 
 * The directive listens to the `input` event on the input field and processes the value by removing
 * any characters that are not numeric using a regular expression.
 * 
 * If the value of the input changes (i.e., non-numeric characters were removed), the propagation 
 * of the event is stopped to prevent any other handlers from interfering.
 */
@Directive({
    selector: 'input[integerOnly]'
})
export class IntegerDirective {
    constructor(private elementRef: ElementRef) { }
    /**
     * Handles the input event when the user types into the input field.
     * 
     * The method:
     * 1. Retrieves the current value of the input field.
     * 2. Replaces any non-numeric characters with an empty string, keeping only digits (0-9).
     * 3. If the value has changed (i.e., non-numeric characters were removed), it stops the event propagation.
     * 
     * @param event The input event triggered when the user types into the field.
     */
    @HostListener('input', ['$event']) onInputChange(event: Event) {
        const initalValue = this.elementRef.nativeElement.value;

        this.elementRef.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');

        if (initalValue !== this.elementRef.nativeElement.value) {
            event.stopPropagation();
        }
    }
}